module.exports = __webpack_public_path__ + "images/stern_small4324e35b5fe23d14d2abeea5ddae7f8c.png";